var defaults = {
    default: {
        navigationOpen: true,
        minContentWidth: 280,
        maxContentWidth: Infinity
    },
    cards: {
        navigationOpen: true,
        minContentWidth: 280,
        maxContentWidth: Infinity
    },
    form: {
        navigationOpen: false,
        minContentWidth: 280,
        maxContentWidth: 800
    },
    table: {
        navigationOpen: true,
        minContentWidth: 280,
        maxContentWidth: Infinity
    },
    wizard: {
        navigationOpen: false,
        minContentWidth: 280,
        maxContentWidth: 1000
    },
    'no-paddings': {
        navigationOpen: true,
        minContentWidth: 280,
        maxContentWidth: Infinity
    }
};
export default {
    get: function (layoutComponent) {
        return defaults[layoutComponent.contentType] || defaults.default;
    }
};
//# sourceMappingURL=defaults.js.map